<span matDialogTitle>{{
  (title ? title : 'Rinomina elemento') | siaTranslate
}}</span>
<mat-dialog-content style="padding: 0.5rem">
  <sia-text-box
    [(value)]="fileName"
    [label]="'Nome'"
    [allowBreakLine]="false"
    (enterPressed)="onConfirm()"
  >
  </sia-text-box>
</mat-dialog-content>

<div matDialogActions align="end">
  <button mat-button (click)="onCancel()" class="error">
    <mat-icon>cancel</mat-icon>
    {{ 'Annulla' | siaTranslate }}
  </button>
  <button mat-button [mat-dialog-close]="fileName">
    <mat-icon>save</mat-icon>
    {{ 'Salva' | siaTranslate }}
  </button>
</div>
